import Vue from 'vue'

const scrollToBottom = el => { el.scrollTop = el.scrollHeight }
const autobottomDirective = {
  inserted: scrollToBottom,
  update: scrollToBottom
}
Vue.directive('autobottom', autobottomDirective)



// WEBPACK FOOTER //
// ./src/directives/autobottom.js